import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { ENTERPRISE_ADMIN_BASE } from '../../config/adminLayers';

const BASE = `${ENTERPRISE_ADMIN_BASE}/voice-infrastructure`;

const TABS = [
  { label: 'Overview', to: BASE },
  { label: 'Voice Platforms', to: `${BASE}/voice-platforms` },
  { label: 'Providers', to: `${BASE}/providers` },
  { label: 'SIP Trunks', to: `${BASE}/sip-trunks` },
  { label: 'Phone Numbers', to: `${BASE}/phone-numbers` },
  { label: 'Carrier Routing', to: `${BASE}/carriers` },
  { label: 'Geographic Routing', to: `${BASE}/geo-routes` },
  { label: 'Health', to: `${BASE}/health` },
  { label: 'Failover', to: `${BASE}/failover` },
  { label: 'Diagnostics', to: `${BASE}/diagnostics` },
  { label: 'Provisioning', to: `${BASE}/provisioning` },
];

export const VoiceInfrastructureLayout: React.FC = () => {
  const tabClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
      isActive
        ? 'bg-enterprise-accent/15 text-enterprise-accent'
        : 'text-enterprise-600 hover:bg-enterprise-100 hover:text-enterprise-900'
    }`;

  return (
    <div className="mx-auto max-w-7xl space-y-6">
      <div className="rounded-2xl border border-enterprise-200 bg-white p-6 shadow-sm">
        <p className="text-xs font-bold uppercase tracking-widest text-sky-700">AI Calling</p>
        <h1 className="mt-2 text-2xl font-bold text-enterprise-900">Voice Infrastructure</h1>
        <p className="mt-2 max-w-3xl text-sm text-enterprise-600">
          Super Admin source of truth for AI Calling. Each workspace selects a Voice Platform
          (Retell or SWS AI Calling) — default is Retell. LiveKit/Asterisk infrastructure for SWS
          remains fully deployed; routing is configuration-driven with no code changes per workspace.
        </p>
        <nav className="mt-4 flex flex-wrap gap-2 border-t border-enterprise-100 pt-4">
          {TABS.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.to === BASE} className={tabClass}>
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
};
